module.exports = __webpack_public_path__ + "img/icon_info.3670b4df.svg";